import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import './index.css';
import './styles.css';

const TemplateWrapper = ({ children }) => (
  <section>
    <Helmet
      title="www.esposi.to - Gianluca Esposito"
      meta={[
        { name: 'description', content: 'The Curious Case of Gianluca Esposito doing development' },
        { name: 'keywords', content: 'blog, development, javascript' },
      ]}
    />

    <section>
      {children()}
    </section>
  </section>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js